module.exports = __webpack_public_path__ + "img/purchase_cover.ade71109.png";